export default __webpack_public_path__ + "static/media/Group 153.0aa0f436.svg";